import React from 'react';

const UnauthorizedPage = () => {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      Unauthorized
    </div>
  );
};

export default UnauthorizedPage;
